import React from "react";
import { StudentsCard } from "./StudentsCard";
import { StudentsUIProvider } from "./StudentsUIContext";

export function StudentsPage({
  history,
  grade,
  sectionId
}) {
  return (
    <StudentsUIProvider>
      <StudentsCard
        history={history}
        grade={grade}
        sectionId={sectionId}
      />
    </StudentsUIProvider>
 );
}